export default __webpack_public_path__ + "static/media/services_04.7bd53e68.jpg";